import {useEffect} from 'react';
import {useProduct} from './useProduct';
import {useSnowplow} from '~/modules/Common/hooks/useSnowplow';

export const usePDPanalytics = () => {
  const product = useProduct();
  const analytics = useSnowplow();
  useEffect(() => {
    //@ts-expect-error selected variant not on type
    const variant = product?.selectedVariant as ProductVariant;

    if (variant && typeof analytics === 'function') {
      const clean = {
        ...variant,
        price: {
          ...variant.price,
          amount: parseFloat(variant.price.amount),
        },
        image: {
          src: variant.image?.url || variant.image?.src || '',
        },
      };
      delete clean.compareAtPrice;
      if (clean.selectedOptions) {
        delete clean.selectedOptions;
      }

      analytics('trackSelfDescribingEvent', {
        event: {
          schema:
            'iglu:com.articaanalytics.shopify.webpixel/product_viewed/jsonschema/1-0-0',
          data: {
            productVariant: clean,
          },
        },
      });
    }
  }, [product?.selectedVariant, analytics]);
};
